import { render } from "./AvatarIcon.vue?vue&type=template&id=0ab62ea2"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"

import "./AvatarIcon.vue?vue&type=style&index=0&id=0ab62ea2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AvatarIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ab62ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ab62ea2', __exports__)) {
    api.reload('0ab62ea2', __exports__)
  }
  
  module.hot.accept("./AvatarIcon.vue?vue&type=template&id=0ab62ea2", () => {
    api.rerender('0ab62ea2', render)
  })

}


export default __exports__